import Dexie from "dexie"

import { Tables } from "@/database/helpers/tables"

export type DexieExtended = Dexie & Tables

export type RepositoryParams = {
  dexie: DexieExtended
  tableName: string
}

export class Repository {
  readonly tableName: string
  protected readonly dexie: DexieExtended

  constructor(params: RepositoryParams) {
    const { dexie, tableName } = params
    this.dexie = dexie
    this.tableName = tableName
  }
}
